import React from "react";
import {ErrorMessage, ErrorTooltip} from 'react-fields';

export default function GroupSelectField(props) {

    let className = props.className || "";
    let disabledPlaceholder = props.disabledPlaceholder || false;


    const renderError = () => {
        switch (props.errorType) {
            case 'tooltip':
                return <ErrorTooltip message={props.errorMessage}/>;
            default:
                return <ErrorMessage message={props.errorMessage}/>;
        }
    };

    const renderOptions = (options) => {
        return options.map((option, index) => {
            return (
                <option key={option.value} value={option.value}>
                    {option.label}
                </option>
            );
        });
    };

    let options = (
        props.options.map(function(group, index){
            return <optgroup key={index} label={group.label}>
                {renderOptions(group.items)}
            </optgroup>;
        })
    );

    let placeholder = '';
    if (props.placeholder) {
        let placeholder_settings = {value: '', key: 'placeholder'};
        if (disabledPlaceholder) { placeholder_settings['disabled'] = true; }
        placeholder = <option {...placeholder_settings}>{props.placeholder}</option>;
    }

    let attributes = {
        name: props.name,
        onChange: props.onChange,
        value: props.selected || "",
        tabIndex: props.tabindex,
        disabled: props.disabled,
        onFocus: props.onFocus,
        onBlur: props.onBlur
    };

    if (!!props.size) {
        attributes['size'] = props.size;
    }

    if (props.required) {
        attributes['required'] = true;
    }

    if (props.id) {
        attributes.id = props.id
    }


    let result = (
        <select {...attributes}>
            {placeholder}{options}
        </select>
    );
    className = className + (props.errorMessage ? " err" : "");
    return  (
        <div className={className}>
            { props.label ?
                <label>{props.label}</label> : ""
            }
            {result}
            {renderError()}
        </div>
    );

}